
import { mapGetters, mapActions } from 'vuex'
import { formatData } from '../../constants/config.js'
export default {
    components: {
        vcLoading		    : () => import('../../components/pages/loading.vue' ),
        vcFormatPrice	    : () => import('../../components/product/format-price.vue' ),
        vcDynamicCustomLink	: () => import('../../components/pages/dynamic-custom-link.vue')
    },
    data() {
        return {
            loadingSidebarCart  : null,
            cartProducts	    : null,
            cartTotal		    : 0,
            countItems		    : 0,
            messages             : [],
            nextCheckout        : false,
            showMessage         : false,
            isLoadingMsg        : true,
        }
    },
    mounted() {
        this.$root.$on('show-sidebar-cart', this.showSidebarCart);
    },
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang : 'getterStoreLang',
            getterCart		: 'getterCart',
            getterSatement  : 'getterSatement',
            getterDraftOrder: 'getterDraftOrder'
        }),
        getLoadingSidebarCart(){
            return this.loadingSidebarCart;
        },
        getLoadingMsg(){
            return this.isLoadingMsg;
        },
        getShowMessage(){
            return this.showMessage;
        },
        getNextCheckout(){
            return this.nextCheckout;
        }
    },
    methods: {
        ...mapActions({
            actionCart              : 'actionCart',
            getStatementByCustomer  : 'getStatementByCustomer',
            createDraftOrderShopify : 'createDraftOrderShopify',
            cleanDraftOrder         : 'cleanDraftOrder'
        }),
        formatCurrency(price, totalAmount = null){
            
            return formatData.currency(price, totalAmount);
        },
        async removeCartItem(product) {
            this.loadingSidebarCart = true;
            await this.actionCart({ action: 'remove', products: [{ product_id: product.product_id, variant_id: product.variant_id, quantity: parseInt(product.quantity) }] }).then( async (result_cart) => {
                
                await this.getStatementByCustomer().then( async (result_statement) => {
                    
                    let num_items = (this.getterCart.products || []).reduce( (previous_item, current_item) => {
                        
                        previous_item += current_item.quantity;
                        return previous_item;
                    }, 0 );
                    this.validNextCheckout( this.getterSatement.balance, this.getterSatement.past_due, num_items );
                });
                this.loadingSidebarCart = null;
            });
        },
        validNextCheckout(balance_customer, expired_days, num_items) {
            
            this.messages = [];
            this.nextCheckout = false;
            this.showMessage = false;
            
            if ( num_items > 0 && expired_days === 0 ) {
                
                this.nextCheckout = true;
                this.showMessage = false;
            }
            else if( ( num_items > 0 ) && expired_days > 0 ) {
                
                this.messages.push(`${ this.getterTranslates.components.pages.card_table.valid_checkout.error_messages[1][this.getterStoreLang] } <strong>${ this.formatCurrency(balance_customer).format }</strong>${ this.getterTranslates.components.pages.card_table.valid_checkout.error_messages[2][this.getterStoreLang] } <strong>${ expired_days }</strong> ${ this.getterTranslates.components.pages.card_table.valid_checkout.error_messages[3][this.getterStoreLang] }`);
                this.nextCheckout = false;
                this.showMessage = true;
            }
            
            this.isLoadingMsg = null;
        },
        async showSidebarCart(is_show){
            if (is_show) {
                this.$refs.sidebarCart.show();
                this.loadingSidebarCart = true;
                await this.getStatementByCustomer().then( async (result_statement) => {
                    
                    let num_items = (this.getterCart.products || []).reduce( (previous_item, current_item) => {
                        
                        previous_item += current_item.quantity;
                        return previous_item;
                    }, 0 );
                    this.validNextCheckout( this.getterSatement?.balance || 0, this.getterSatement?.past_due || 0, num_items );
                });
                this.loadingSidebarCart = null;
            } 
            else {
                this.$refs.sidebarCart.hide();
            }
        },
        closeSidebarCart(event, navigate){
            
            this.$refs.sidebarCart.hide();
            navigate(event);
        },
        async createDraftOrder(){
            let order_data = {
                products: this.getterCart.products,
                product_origin: "cart"
            };
            this.loadingSidebarCart = true;
            await this.createDraftOrderShopify( formatData.draftOrder( order_data, null, null ) ).then( (result) => {
                
                if( this.getterDraftOrder != null ){
                    
                    let invoice_url         = this.getterDraftOrder.invoice_url;
                    this.cleanDraftOrder();
                    window.location.href    = invoice_url;
                }
                this.loadingSidebarCart = null;
            });
        }
    }
}
